export default {
  // TaxonomyView
  defaultTaxonomyMessage: 'This is the default {taxonomy} for the Institution.',
  level: 'Level',
  verb: 'Verb',
  verbs: 'Verbs',
  noCognitiveLevelsCreated: 'No Cognitive Levels created.',
  createCognitiveLevel: 'Create Cognitive Level',
  verbsWithoutCognitiveLevel: 'Verbs used without Cognitive Level',
  noVerbsToShow: 'No verbs to show.',

  // TaxonomyForm
  default: 'Default',
  defaultTaxonomyDescription: 'Defines if the {taxonomy} will be the default for the Institution.',
  defaultTaxonomyTooltip: 'If activated, the rest of the {taxonomies} will be modified so that this is the only active one.',

  // CognitiveLevelForm
  defaultColor: 'Default color:',
  applyDefaultColor: 'Apply default color',
  colorLabel: 'Color:',

  // CognitiveLevelRow
  levelLabel: 'Level {level}',
  insertNamePlaceholder: 'Insert the name here...',
  insertDescriptionPlaceholder: 'Insert the description here...',
  changeColor: 'Change Color',
  dragToOrder: 'Drag to order the {cognitiveLevel}.',
  editCognitiveLevel: 'Edit Cognitive Level',
  changeColorTo: 'Change color to {cognitiveLevel}',
  cognitiveLevelCreated: '{cognitiveLevel} created.',
  cognitiveLevelUpdated: '{cognitiveLevel} updated.',
}
